const leftPanel = require('../../shop/views/left-panel.view.html').trim(),
    centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim();

module.exports = function ($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.hashPrefix('!');

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false,
    });

    // Configuring the stateProvider is actually quite expensive and so in tests, the below feature is 'enabled'
    // This is a HACK, temporary. Should be replaced with mocking stateProvider or switching routing library.
    if (window.wowFeatures.isEnabled('route-config-test-mode')) {
        return;
    }

    // Declares the root state
    require('./root')($stateProvider);

    // If you add a route here that doesn't exist on the old site (ShopController)
    // you must also add it to RouteConfig.cs to prevent errors.
    $stateProvider
        .state('shop', {
            url: '/shop?accessToken',
            parent: 'root',
            onEnter: ['$stateParams', '$state', function ($stateParams, $state) {
                if ($stateParams.accessToken) {
                    $state.go('root');
                }
            }],
            views: {
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-generic-instrumentation></wow-rr-generic-instrumentation>',
                },
                'content@root': {
                    template: `${leftPanel} ${centerPanel} ${rightPanel}`,
                },
            },
        })
        .state('shop.trackmyorder', {
            url: '/trackmyorder?OrderNumber',
            resolve: {
                authenticationMethod: ['ShopperService', shopperService => shopperService.getAuthenticationMethod()],
            },
            onEnter: ['$state', 'ShopperService', 'authenticationMethod', function ($state, shopperService, authenticationMethod) {
                if (!shopperService.IsGuest && authenticationMethod.AuthenticationMethod !== 'RememberMe') {
                    $state.transition.then(() => $state.go('shop.myaccount.trackmyorder.orderId', { orderId: $state.params.OrderNumber }, { location: 'replace' }));
                }
            }],
            views: {
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
                'center-panel@shop.trackmyorder': {
                    template: '<wow-trackmyorder-guest-form></wow-trackmyorder-guest-form>',
                },
            },
        })
        .state('shop.unsubscribeedm', {
            url: '/unsubscribeedm?shopperID&checksum&documentID',
            views: {
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
                'center-panel@shop.unsubscribeedm': {
                    template: '<wow-unsubscribe-edm></wow-unsubscribe-edm>',
                },
            },
        });


    // Feature routes
    require('./browse')($stateProvider);
    require('./catalogue')($stateProvider);
    require('./search')($stateProvider);
    require('./recipes')($stateProvider);
    require('./inspiration')($stateProvider);
    require('./myaccount')($stateProvider);
    require('./lists')($stateProvider);
    require('./authentication')($stateProvider);
    require('./embedded')($stateProvider);
    require('./checkout')($stateProvider);
    require('./productgroups')($stateProvider);
    require('./partners')($stateProvider);
    require('./accessibility')($stateProvider);
    require('./page')($stateProvider);
    require('./print')($stateProvider);
    require('./productdetail')($stateProvider);
    require('./cart')($stateProvider);
    require('./stores')($stateProvider);
    require('./new')($stateProvider);
    require('./error')($stateProvider);
    require('./addtotrolley')($stateProvider);
    require('./offergroups')($stateProvider);

    // Other states
    require('./diagnostics')($stateProvider);

    $urlRouterProvider.otherwise('/ResourceNotFound');
};



// WEBPACK FOOTER //
// ./src/configuration/routes/index.js